import React, { Component } from 'react'
import ReactTable from 'react-table'
import './react-table.css'

export default class StnResults extends Component {

  buildData = (qcmessages) => {
    let extractMessages = (qcm) => qcm["hours"].map((hr, i) => {
      let gridext = ""
      if (qcm["grid"]) {
        const gridrange = this.props.qcVar === 'pcpn' || parseInt(hr, 0) <= 7 ? [qcm["grid"][0], qcm["grid"][1]] : [qcm["grid"][2], qcm["grid"][3]]
        const ind = qcm.test.indexOf("LOW")
        const sign = gridrange[1] === 0 ? "" : (ind >= 0 ? ">=" : "<=")
        gridext = sign + (ind >= 0 ? gridrange[0] : gridrange[1])
      }
      return  {
        'hour': hr,
        'station': qcm["values"][i].length >= 2 ? qcm["values"][i][0] : qcm["values"][i],
        'icao': qcm["values"][i].length >= 2 ? qcm["values"][i][1] : "-",
        'newa': qcm["values"][i].length === 3 ? qcm["values"][i][2] : "-",
        'grid': gridext
      }
    })
    return qcmessages.map((qcm) => {
      return extractMessages(qcm)
    })
  }

  buildColumns = (qcresults) => {
    let cl = [
      {Header: 'Hour', accessor: 'hour', width: 60},
      {Header: this.props.stnId.split(" ")[0], accessor: 'station', width: 80},
      {Header: qcresults.closeIcao.split(" ")[0], accessor: 'icao', width: 80},
      {Header: qcresults.closeNewa.split(" ")[0], accessor: 'newa', width: 80},
    ]
    if (this.props.qcVar === "temp" || this.props.qcVar === "pcpn") {
      cl.push({Header: "Grid", accessor: 'grid', width: 80})
    }
    return cl
  }

  render() {
    const qcresults = this.props.qcresults
    const hd = this.buildData(qcresults.messages)
    const cl = this.buildColumns(qcresults)
    return (
      <div style={{borderTop: "2pt double black"}}>
        <p style={{fontWeight: "bold"}}>
          Station - {qcresults.name}, {qcresults.state} ({this.props.stnId})
        </p>
        {qcresults.messages.map((msg, n) => (
          <div key={n} style={{borderBottom:"1pt dotted blue", padding:"4px 0"}}>
            <span>{msg.date} - {msg.test.replace("newa ","")}</span>
            <ReactTable 
              columns={cl} 
              data={hd[n]} 
              showPagination={false} 
              defaultPageSize={24} 
              minRows="0" 
              style={{width:this.props.qcVar === 'temp' || this.props.qcVar === 'pcpn' ? '380px' : '300px'}}
              className={"-highlight"}
            />
          </div>
        ))}
      </div>
    )
  }
}

//Following not needed:
//{msg.numIcaoAbove && <span>Icao Above={msg.numIcaoAbove}</span>}
//{msg.numNewa2Above && <span>, Newa Above={msg.numNewa2Above}</span>}
//{msg.numIcaoBelow && <span>Icao Below={msg.numIcaoBelow}</span>}
//{msg.numNewa2Below && <span>, Newa Below={msg.numNewa2Below}</span>}



// WEBPACK FOOTER //
// ./src/StnResults.js